import './Blocks/FilterableTabularData/view.js';
import './Blocks/front.scss';

console.log(`[efi-data] Front module loaded.`);
